import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 p-6 bg-white rounded-xl shadow-md mt-12">
        <div>
          <img
            className="mx-auto h-12 w-auto"
            src="https://consultala.com/static/images/consultala2.png"
            alt="Your Logo"
          />
          <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-800">
            <WrenchScrewdriverIcon className='text-indigo-700 h-8 w-8 me-4 inline-block' />
            Funzionalità in arrivo
          </h2>
        </div>
        <p className="text-center text-sm text-gray-600">
          Il nostro team di sviluppo sta lavorando per implementare questa funzionalità il prima possibile.
        </p>
      </div>
    </div>
  );
}